import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SUPPORT_STATE = { subject: 'support', message: 'Hi, I need help with ' };

const navLinks = [
  { to: '/products', labelKey: 'nav.products' },
  { to: '/certificates', labelKey: 'nav.contracts' },
  { to: '/pricing', labelKey: 'nav.pricing' },
  { to: '/support', labelKey: 'nav.support', state: SUPPORT_STATE },
  { to: '/contact', labelKey: 'nav.contact' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="container navbar-content">
        <Link to="/" className="navbar-brand">
          <img src="/icon.png" alt="Cornetto Pro" className="navbar-icon" />
          <span className="navbar-tagline">
            <span className="tagline-verify">Verify</span>
            <span className="tagline-sep"> · </span>
            <span className="tagline-certify">Certify</span>
            <span className="tagline-sep"> · </span>
            <span className="tagline-deliver">Deliver</span>
          </span>
        </Link>

        <div className="navbar-links">
          {navLinks.map((link) => (
            <Link
              key={link.labelKey}
              to={link.to}
              state={link.state}
              className={`navbar-link ${location.pathname === link.to ? 'active' : ''}`}
            >
              {t(link.labelKey)}
            </Link>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="container">
          {navLinks.map((link) => (
            <Link
              key={link.labelKey}
              to={link.to}
              state={link.state}
              className={`mobile-menu-link ${location.pathname === link.to ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {t(link.labelKey)}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
